import { HandlerProps, HasOnError, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import { GetAlsoPurchasedProductCollectionApiV2Parameter, GetProductCollectionApiV2Parameter, GetRelatedProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { getSelectedCategoryPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

import {
    chain,
    DispatchCompleteLoadProducts,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";

replaceInChain(chain, DispatchCompleteLoadProducts, props => {
        const state = props.getState() as unknown as CustomApplicationState;
        const location = getLocation(state);
        const categoryPath = getSelectedCategoryPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
        const catalogPageState = getCatalogPageStateByPath(state, categoryPath);
        const category = getCategoryState(state, catalogPageState.value?.categoryIdWithBrandId ?? catalogPageState.value?.categoryId).value;

        const { onSuccess, onError, isLoadMore, ...parameter } = props.parameter;
        props.apiParameter = parameter;
    
        if (props.parameter.isLoadMore) {
            const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
            prevApiParams.page =
                props.apiParameter.page && props.apiParameter.page > 1 ? props.apiParameter.page - 1 : undefined;
            const prevProducts = getProductsDataView(props.getState(), prevApiParams).value;

            if (prevProducts && props.apiResult.products )  {
                props.apiResult.products =  [...prevProducts, ...props.apiResult.products];
            }
            if (!prevProducts && props.parameter.page && props.parameter.page > 1) {
                props.apiParameter.page = props.parameter.page;
                props.apiParameter.pageSize = props.parameter.pageSize;
            }
        }
        if(category?.properties?.indexImage || category?.properties?.indexImage2){
            addPromoImageOnPLP(props, category);        
        }
    
        props.dispatch({
            type: "Data/Products/CompleteLoadProducts",
            collection: props.apiResult,
            parameter: props.apiParameter,
        });
    
 
});
function createPromoImageData(
    index: number,
    promoImagePath: string,
    promoImageURL: string 
): ProductModel {
    return {
        uri:promoImageURL,
        allowZeroPricing: true,
        brand: null,
        canAddToCart: false,
        canAddToWishlist: false,
        canConfigure: false,
        canonicalUrl: promoImageURL,
        canShowPrice: false,
        canShowUnitOfMeasure: false,
        configurationType: "None",
        customerProductNumber: "",
        customerUnitOfMeasure: "",
        id: `Temp-${index}`,
        imageAltText: "",
        isDiscontinued: false,
        isSponsored: false,
        isVariantParent: false,
        largeImagePath: promoImagePath,
        manufacturerItem: "",
        mediumImagePath: promoImagePath,
        minimumOrderQty: 0,
        packDescription: "",
        priceFacet: null,
        productLine: null,
        productNumber: "",
        productTitle: "",
        quoteRequired: false,
        defaultChildProductId:null,
        score: 0,
        smallImagePath: promoImagePath,
        trackInventory: false,
        unitListPrice: 0,
        unitListPriceDisplay: "",
        unitOfMeasures: null,
        urlSegment: promoImageURL,
        variantTypeId: null,
        salePriceLabel: "",
        cantBuy: true,
        properties:{}
    };
}
function addPromoImageOnPLP(
    props: HandlerProps<
        (GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter | GetAlsoPurchasedProductCollectionApiV2Parameter) &
        HasOnSuccess<ProductModel[]> &
        HasOnError<string>,
        {
            apiParameter: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter | GetAlsoPurchasedProductCollectionApiV2Parameter;
            apiResult: ProductCollectionModel;
        }
    >,
    category: Category | undefined
) {

    if (!props.apiResult.products || !category?.properties) {return;}
    let promoImagesToAdd = 0;
if (category.properties.indexImage && category.properties.indexImage2 && (props.apiResult.pagination && props.apiResult.pagination?.page > 1)) {
  promoImagesToAdd = 2; 
} else if ((category.properties.indexImage || category.properties.indexImage2) && (props.apiResult.pagination && props.apiResult.pagination?.page > 1)) {
  promoImagesToAdd = 1; 
}

    const firstImageIndex = parseInt(category.properties.indexImage || "0", 10);
    const secondImageIndex = parseInt(category.properties.indexImage2 || "0", 10);


const calculatePromoIndex = (pageSize: number, currentPage: number , imageIndex: number) => {
    const offset = pageSize * (currentPage - 1);
    const totalLoadedItems = offset + imageIndex; 
    return totalLoadedItems;
  };
  
  // Insert first promo image
  if (category.properties.indexImage && props.apiResult.products.length > firstImageIndex && props.apiResult.pagination) {
    const promoIndex1 = calculatePromoIndex(
      props.apiResult.pagination?.pageSize + promoImagesToAdd,
      props.apiResult.pagination?.page,
      firstImageIndex
    );
    const promoImageData1 = createPromoImageData(promoIndex1, category.properties.promoImage, category.properties.promoImgURL);
    props.apiResult.products.splice(promoIndex1, 0, promoImageData1);
  }
  
  // Insert second promo image
  if (category.properties.indexImage2 && props.apiResult.products.length > secondImageIndex && props.apiResult.pagination) {
    const promoIndex2 = calculatePromoIndex(
      props.apiResult.pagination?.pageSize + promoImagesToAdd,
      props.apiResult.pagination?.page,
      secondImageIndex
    );
    const promoImageData2 = createPromoImageData(promoIndex2, category.properties.promoImage2, category.properties.promoImgURL2);
    props.apiResult.products.splice(promoIndex2, 0, promoImageData2);
  }

}






